module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-bottom": "30px"
    }
  }, [_c('el-collapse', {
    attrs: {
      "value": "1",
      "accordion": ""
    }
  }, [_c('el-collapse-item', {
    attrs: {
      "name": "1",
      "title": "礼品卡规格"
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.giftCardSpecInfo,
      "label-width": "100px",
      "inline": "",
      "disabled": ""
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "主题"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.giftCardSpecInfo.topicName),
      callback: function($$v) {
        _vm.$set(_vm.giftCardSpecInfo, "topicName", $$v)
      },
      expression: "giftCardSpecInfo.topicName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "卡片名称"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.giftCardSpecInfo.cardName),
      callback: function($$v) {
        _vm.$set(_vm.giftCardSpecInfo, "cardName", $$v)
      },
      expression: "giftCardSpecInfo.cardName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "卡片封面"
    }
  }, [_c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.giftCardSpecInfo.topicCover
    }
  })]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "祝福语"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.giftCardSpecInfo.blessingWords),
      callback: function($$v) {
        _vm.$set(_vm.giftCardSpecInfo, "blessingWords", $$v)
      },
      expression: "giftCardSpecInfo.blessingWords"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "卡片面值",
      "prop": "amount"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.giftCardSpecInfo.amount),
      callback: function($$v) {
        _vm.$set(_vm.giftCardSpecInfo, "amount", $$v)
      },
      expression: "giftCardSpecInfo.amount"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "卡片类型",
      "prop": "cardType"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.giftCardSpecInfo.cardTypeName),
      callback: function($$v) {
        _vm.$set(_vm.giftCardSpecInfo, "cardTypeName", $$v)
      },
      expression: "giftCardSpecInfo.cardTypeName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "有效期类型",
      "prop": "validType"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.giftCardSpecInfo.validTypeName),
      callback: function($$v) {
        _vm.$set(_vm.giftCardSpecInfo, "validTypeName", $$v)
      },
      expression: "giftCardSpecInfo.validTypeName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "有效期"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.giftCardSpecInfo.validValue),
      callback: function($$v) {
        _vm.$set(_vm.giftCardSpecInfo, "validValue", $$v)
      },
      expression: "giftCardSpecInfo.validValue"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "状态",
      "prop": "status"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.giftCardSpecInfo.statusName),
      callback: function($$v) {
        _vm.$set(_vm.giftCardSpecInfo, "statusName", $$v)
      },
      expression: "giftCardSpecInfo.statusName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "备注"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.giftCardSpecInfo.remark),
      callback: function($$v) {
        _vm.$set(_vm.giftCardSpecInfo, "remark", $$v)
      },
      expression: "giftCardSpecInfo.remark"
    }
  })], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/template-compiler?{"id":"data-v-94d2b264","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!/opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/biz/giftCard/components/specInfo.vue
// module id = 1731
// module chunks = 0